export function cleanQuery(query: string): string {
  return query.trim().replace(/\s+/g, ' ');
}

export function matchesQuery(query: string, lastQuery: string): boolean {
  return cleanQuery(query).toLowerCase() === cleanQuery(lastQuery).toLowerCase();
}
